"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfRequestedShiftDto = instanceOfPaginatedResponseOfRequestedShiftDto;
exports.PaginatedResponseOfRequestedShiftDtoFromJSON = PaginatedResponseOfRequestedShiftDtoFromJSON;
exports.PaginatedResponseOfRequestedShiftDtoFromJSONTyped = PaginatedResponseOfRequestedShiftDtoFromJSONTyped;
exports.PaginatedResponseOfRequestedShiftDtoToJSON = PaginatedResponseOfRequestedShiftDtoToJSON;
exports.PaginatedResponseOfRequestedShiftDtoToJSONTyped = PaginatedResponseOfRequestedShiftDtoToJSONTyped;
const RequestedShiftDto_1 = require("./RequestedShiftDto");
const PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1 = require("./PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta");
/**
 * Check if a given object implements the PaginatedResponseOfRequestedShiftDto interface.
 */
function instanceOfPaginatedResponseOfRequestedShiftDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfRequestedShiftDtoFromJSON(json) {
    return PaginatedResponseOfRequestedShiftDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfRequestedShiftDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(RequestedShiftDto_1.RequestedShiftDtoFromJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfRequestedShiftDtoToJSON(json) {
    return PaginatedResponseOfRequestedShiftDtoToJSONTyped(json, false);
}
function PaginatedResponseOfRequestedShiftDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(RequestedShiftDto_1.RequestedShiftDtoToJSON)),
        'meta': (0, PaginatedResponseOfFacilityOrientationListItemDtoAllOfMeta_1.PaginatedResponseOfFacilityOrientationListItemDtoAllOfMetaToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfRequestedShiftDto.js.map